import React, { useEffect, useState } from "react";
import { AxiosError } from "axios";
import { t } from "i18next";
import i18n from "../../i18n";
import {
  Typography,
  Divider,
  Row,
  Col,
  Avatar,
  Button,
  Input,
  Tag,
  Upload,
  message,
  Popconfirm,
  Modal,
  Select,
  Form
} from "antd";
import ColoredButton from "antd-button-color";
import {Clipboard} from 'ts-clipboard';
import {
  CheckCircleOutlined,
  PaperClipOutlined,
  SyncOutlined,
  CopyOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { UploadRequestOption } from "rc-upload/lib/interface";
import { TeamModel } from "../../api/track";
import jwt, { JwtPayload } from "jsonwebtoken";
import { useLocation, useHistory } from "react-router-dom";
import { useAppSelector } from "../../store/hook";
import { newTeam, sendApplication } from "../../api/team"
import {
  getTeam,
  deleteTeam,
  TeamApplication,
  updateTeamApplication,
  verifyUserApplication,
  updateTeam,
} from "../../api/team";
import { getTeamAvatarUploadCOS } from "../../cos/avatar";
import COS from "cos-js-sdk-v5";
import { getProfile, PublicProfile } from "../../api/account";
const { Title, Paragraph, Text } = Typography;
interface IMember {
  role: "master" | "apply" | "user";
  memberId: number;
  approve?: () => void;
  reject?: () => void;
}
const { Option } = Select;
const TeamMember: React.FunctionComponent<IMember> = (props) => {
  const location = useLocation();
  const history = useHistory();
  const { memberId, approve, reject } = props;
  const key = useAppSelector((state) => state.user.key);
  const [profile, setProfile] = useState<PublicProfile>();
  
  useEffect(() => {
    getProfile(key, memberId).then((data) => {
      setProfile(data);
    });
  }, [location, key, history, memberId]);
  const colors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];

  return (
    <Row>
      <Col key="1" span={2} offset={1} style={{ textAlign: "left" }}>
        <Avatar
          size={48}
          src={`https://avatar-1256691515.cos.ap-guangzhou.myqcloud.com/avatar-${memberId}.png`}
          style={{
            backgroundColor: colors[(profile?.id || 0) % 11],
            fontSize: "20px",
          }}
        >
          {profile?.name[0]}
        </Avatar>
      </Col>
      <Col key="2" span={4} offset={0}>
        <Text>{profile?.name}</Text>
        <br />
        <Text type="secondary">@{profile?.id}</Text>
      </Col>
      <Col key="3" span={4} offset={1} style={{ textAlign: "right" }}>
        {props.role === "master"
          ? t("创始人")
          : props.role === "apply"
            ? t("待审核")
            : t("开发者")}
      </Col>

      <Col key="4" span={4} offset={2} style={{ textAlign: "left" }}>
        {props.role !== "apply" ? (
          <Tag icon={<CheckCircleOutlined />} color="success">
            {t("正常")}
          </Tag>
        ) : (
          <Tag icon={<SyncOutlined spin />} color="processing">
            {t("申请加入")}
          </Tag>
        )}
      </Col>

      <Col key="5" span={4} offset={2} style={{ textAlign: "left" }}>
        <ColoredButton
          shape="circle"
          type="success"
          disabled={props.role !== "apply"}
          ghost={props.role === "apply"}
          icon={<CheckOutlined />}
          onClick={approve}
        />
        <Button
          shape="circle"
          danger
          disabled={props.role !== "apply"}
          icon={<CloseOutlined />}
          onClick={reject}
        />
      </Col>
      <Divider />
    </Row>
  );
};
interface ITeam {
  contestId: number;
  trackId: number;
  teamId: number;
}
export const Team: React.FunctionComponent<ITeam> = (props) => {
  const colors = [
    "magenta",
    "red",
    "volcano",
    "orange",
    "gold",
    "lime",
    "green",
    "cyan",
    "blue",
    "geekblue",
    "purple",
  ];

  const location = useLocation();
  const history = useHistory();

  const key = useAppSelector((state) => state.user.key);
  const id = useAppSelector(
    (state) => (jwt.decode(state.user.key) as JwtPayload)?.id || 0
  );
  const { contestId, trackId, teamId } = props;
  const [team, setTeam] = useState<TeamModel>();
  const [teamApplication, setTeamApplication] = useState<TeamApplication[]>([]);
  const [teamCOS, setTeamCOS] = useState<COS>();
  const [keyState, setKeyState] = useState(0);
  const [visible, setVisible] = React.useState(false);
  const [form] = Form.useForm();
  useEffect(() => {
    getTeam(key, contestId, trackId, teamId).then((data) => {
      // console.log("setTeam", data);
      setTeam(data);
    });
    setTeamCOS(getTeamAvatarUploadCOS(key, contestId, trackId, teamId));
  }, [location, key, id, history, contestId, trackId, teamId]);
  useEffect(() => {
    if (team?.leader === id) {
      updateTeamApplication(key, contestId, trackId, teamId).then((data) => {
        setTeamApplication(data);
      });
    }
  }, [team, key, contestId, trackId, teamId, id]);

  const leave = () => {
    let isleader = false;
    team?.members.map((x) => (
     ( x.id == id && x.isLeader == true )?isleader=true:isleader=isleader
    ))
    if(true/*isleader (checked on background)*/){
      //delete
      deleteTeam(key,contestId,trackId,teamId).then((data)=>{
        //console.log(data);
        message.info("退出/解散成功，请刷新页面");
        window.location.reload(); 
      })
      .catch((error: AxiosError) => message.error("退出/解散失败 "+error));
    }else{
      //quit

      message.info("quit")
    }
  }



  const upload = (prop: UploadRequestOption) => {
    if (teamCOS) {
      teamCOS.putObject(
        {
          Bucket: "avatar-1256691515",
          Region: "ap-guangzhou",
          Key: `team-${teamId}.png`,
          Body: prop.file,
          onProgress(progressData) {
            if (prop.onProgress)
              prop.onProgress({
                ...new Event("onProgress"),
                ...progressData,
                lengthComputable: false,
              });
            return;
          },
        },
        function (err, data) {
          if (err) {
            if (prop.onError) prop.onError(err.error as Error);
            message.error("更新头像失败");
          } else {
            setKeyState((x) => x + 1);

            message.success("更新头像成功");
            if (prop.onSuccess)
              prop.onSuccess({ ...data }, new XMLHttpRequest());
          }
        }
      );
    }
  };
  const setvis = () => {
    setVisible(true)
  }
  const setunvis = () => {
    setVisible(false)
  }
  const onFinish = (teamName: any) => {
    // teamName.name
    // trackRegister(key, contestId, trackId).then(
      console.log(teamName);
      if(!teamName.opensource){
        teamName.opensource = "null";
      }
      console.log(teamName || "", team?.openSource||"");
      updateTeam(key, contestId, trackId, team?.id||0, {
        teamName:teamName.name,
        schoolName:team?.schoolName||"",
        region:team?.region||"",
        openSource:teamName.opensource
    }).then(
      data => {
        message.info("修改成功");
        window.location.reload(); 
      }
    ).catch(err => {
      console.log(err)
      message.info("修改失败" + err)
    })
    setVisible(false)
  }
  const onFinishFailed = () => {
    message.error("修改失败，请联系管理员")
    setVisible(false)
  }
  const onOk = () => {
    form.submit();
  };
  return (
    <div className="site-layout-content">
    <Modal
        title={t("编辑队伍")}
        visible={visible}
        onOk={onOk}
        onCancel={setunvis}
        destroyOnClose
        maskClosable={false}
        keyboard={false}
      >
        <Form
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item
            label={t("队名")}
            name="name"
            rules={[{ required: true, message: '请输入新队伍名' }, { pattern: /^[\u4E00-\u9FFFa-zA-Z0-9_]+$/, message: '用户名应为中文字符、英文字母、数字或下划线构成' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item label={t('开源协议')} name="opensource">
          <Select defaultValue="null" style={{ width: 120 }}>
            <Option value="MIT">MIT</Option>
            <Option value="Apache">Apache</Option>
            <Option value="BSD">BSD</Option>
            <Option value="qizhi">{t("启智开源")}</Option>
            <Option value="null">{t("不开源")}</Option>
          </Select>
        </Form.Item>
        </Form>
      </Modal>
      <Row>
        <Col span={8} offset={1}>
          <Title level={3}>{t("队伍名称")}</Title>
        </Col>
      </Row>
      <Row>
        <Col span={14} offset={1}>
          <Title level={5}>{team?.teamName}</Title>
        </Col>
        <Col span={14} offset={1}>
          <Title level={5}>{t("开源类型")}:{ (team?.openSource||"null")=="null" ? t('不开源') : (team?.openSource||"")}</Title>
        </Col>
        <Col span={7} offset={1}>
          <Button onClick={
            setvis
          }
            type="primary"
          >{t("修改")}</Button>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={8} offset={1}>
          <Title level={3}>{t("队伍头像")}</Title>
          <Paragraph>
            {t("你可以在用户信息处修改你的头像，这是队伍的头像，仅可以在这里修改。")}
          </Paragraph>
        </Col>
        <Col span={4} offset={1}>
          <Avatar
            size={136}
            src={`https://avatar-1256691515.cos.ap-guangzhou.myqcloud.com/team-${teamId}.png?${keyState}`}
            style={{ backgroundColor: colors[teamId % 11], fontSize: "5em" }}
          >
            {team?.teamName[0]}
          </Avatar>
        </Col>
        <Col span={8} offset={1}>
          <Upload name="avatar" showUploadList={false} customRequest={upload}>
            <Paragraph>{t("点击按钮上传新头像并自动修改")}</Paragraph>
            <Button> {t("上传新头像")}</Button>
          </Upload>
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={22} offset={1}>
          <Title level={3}>{t("队伍成员")}</Title>
          <Divider />
          <Row>
            <Col span={5} offset={1} style={{ textAlign: "center" }}>
              <Title level={5}>{t("成员账号")}</Title>
            </Col>
            <Col span={4} offset={2} style={{ textAlign: "center" }}>
              <Title level={5}>{t("角色")}</Title>
            </Col>
            <Col span={4} offset={2} style={{ textAlign: "left" }}>
              <Title level={5}> {t("成员状态")}</Title>
            </Col>
            <Col span={4} offset={2} style={{ textAlign: "left" }}>
              <Title level={5}> {t("操作")}</Title>
            </Col>
          </Row>
          <Divider />
          {team?.members.map((x) => (
            <TeamMember memberId={x.id} role={x.isLeader ? "master" : "user"} />
          ))}
          <Divider />
          {teamApplication
            .filter((x) => x.status === "waiting")
            .map((x) => (
              <TeamMember
                memberId={x.user}
                role="apply"
                approve={() => {
                  verifyUserApplication(
                    key,
                    contestId,
                    trackId,
                    teamId,
                    x.id,
                    "approved"
                  )
                    .then(() => {
                      message.success("确认成功");
                      getTeam(key, contestId, trackId, teamId).then((data) => {
                        setTeam(data);
                      });
                    })
                    .catch((error: AxiosError) => {
                      message.error("确认失败 "+error);
                    });
                }}
                reject={() => {
                  verifyUserApplication(
                    key,
                    contestId,
                    trackId,
                    teamId,
                    x.id,
                    "rejected"
                  )
                    .then(() => message.success("拒绝成功"))
                    .catch((error: AxiosError) => message.error("拒绝失败 "+error));
                }}
              />
            ))}
        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={7} offset={1}>
          <Title level={3}>Repo</Title>
        </Col>
      </Row>
      <Row>
        <Col span={6} offset={1}>
          <Paragraph>
            {t("每一个队伍相应地在OpenI有一个队伍仓库，请尽情地使用吧。")}
          </Paragraph>
        </Col>
        <Col span={15} offset={1}>
          <Row>
          <Input
            size="large"
            defaultValue="https://git.openi.org.cn/testUser/testRepo"
            value= {team?.giturl}
          />

          </Row>
          <Row>
          <Col span={12}>
          <Button size="large" icon={<CopyOutlined />} style={{width:200, marginTop:10}}
              onClick={() => {
                Clipboard.copy(team?.giturl||"请先登录");
            }}
              >
                {t("拷贝链接")}
              </Button>
          </Col>
          <Col span={10}>
          <Button
            type="primary"
            size="large"
            href={team?.giturl} style={{width:200, marginTop:10}}
            icon={<PaperClipOutlined />}
          >
            {t("跳转至仓库")}
          </Button>
          </Col>
          </Row>

        </Col>
      </Row>
      <Divider />
      <Row>
        <Col span={7} offset={1}>
          <Title level={3}>{t("离开队伍")}</Title>
        </Col>
      </Row>
      <Row>
        <Col span={7} offset={1}>
          <Popconfirm placement="bottom" title={t("您将离开队伍，如果您是队长那么队伍将被解散")} onConfirm={leave} okText="Yes" cancelText="No" >
            <Button danger size="large">{t("退出/解散队伍")}</Button>
          </Popconfirm>
        </Col>
      </Row>

    </div>
  );
};

export default Team;
